module.exports = __webpack_public_path__ + "static/media/venvi2.d589eeb4.gif";